module.exports = __webpack_public_path__ + "static/media/ic-quiz.b152df93.svg";